import React, {Component} from 'react';
import {Factory} from './components/mobile/factory';
import {connect} from 'react-redux';

class StackSummary extends Component {
    render() {
        const {sportConfig} = this.props;

        const ViewComponent = Factory.getComponent(sportConfig);

        if (ViewComponent) {
            return <ViewComponent />;
        }

        return null;
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
    } = state;

    return {
        sportConfig,
    };
}

const StackSummaryComponent = connect(mapStatesToProps)(StackSummary);

export {StackSummaryComponent};
